import Phaser from 'phaser';
import { Enemy } from './Enemy';
import type { EnemyConfig } from './Enemy';

export class EvilEgg extends Enemy {
  private wobbleTime: number = 0;
  private baseY: number;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    const config: EnemyConfig = {
      texture: 'evilEgg',
      points: 10,
      health: 1,
      fireRate: 2000, // Fire every 2 seconds max
      projectileSpeed: 200,
      projectileTexture: 'yolkProjectile',
    };

    super(scene, x, y, config);
    this.baseY = y;
    
    // Set hitbox size
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setSize(28, 28);
    
    // Random starting wobble phase
    this.wobbleTime = Math.random() * Math.PI * 2;
  }

  update(_time: number, delta: number): void {
    // Wobble animation
    this.wobbleTime += delta * 0.003;
    this.y = this.baseY + Math.sin(this.wobbleTime) * 2;
    this.rotation = Math.sin(this.wobbleTime * 0.5) * 0.1;
  }

  updateBaseY(newY: number): void {
    this.baseY = newY;
  }
}

